@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    padding-top: var(--spacer-80);

    & > :first-child {
        grid-column: span 4;
    }
}

.right {
    grid-column: 6 / span 7;

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.form {
    composes: right;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--labui-grid-gap);

    button[type="submit"] {
        width: fit-content;
    }

    @media ($below-mobile) {
        grid-template-columns: auto;
    }
}

.results {
    composes: right;
    margin-block: auto;
}
